export default __webpack_public_path__ + "static/media/homer3.466fcdf6.png";